import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { artBoardActions } from '@store/reducers/artboard'
import { managerActions } from '@store/reducers/manager/actions'
import {
  activityHistoryActions,
  type RestoreSagaPayload,
} from '@store/reducers/manager/activityHistory/actions'
import { socket } from '@store/socketSaga'
import axios, { type AxiosResponse } from 'axios'
import { call, put, select } from 'redux-saga/effects'

const projectRestoreRequest = ({
  projectId,
  actionId,
}: {
  projectId: string
  actionId: string
}): Promise<AxiosResponse<any>> => {
  const token = localStorage.getItem('token')

  return axios.post(
    `/projects/${projectId}/restore`,
    { actionId },
    {
      baseURL: import.meta.env.VITE_SYNC_HTTP_URL,
      headers: {
        'X-Auth-Socket-Id': socket.id,
        'X-Auth-Token': token,
      },
    }
  )
}

export function* restoreSaga(action: { payload: RestoreSagaPayload }) {
  try {
    const { id: actionId } = action.payload

    yield put({
      type: activityHistoryActions.setIsLoading.type,
    })

    yield put(artBoardActions.setActivityHistoryStatus({ status: true }))

    // @ts-expect-error
    const projectId = yield select(migrationProjectSelector.getProjectId)

    // @ts-expect-error
    const response = yield call(
      // @ts-expect-error
      projectRestoreRequest,
      { projectId, actionId }
    )

    if (response.status !== 200) {
      throw new Error(
        `Request of restoring project failed with status ${response.status}`
      )
    }

    const {
      data: {
        payload: { project, relations },
      },
    } = response

    yield put({
      type: managerActions.updateProjectAndRelations.type,
      payload: {
        project,
        relations,
      },
    })

    yield put(artBoardActions.setActivityHistoryStatus({ status: false }))
    yield put(artBoardActions.changeMode('edit'))
  } catch (error) {
    console.error('Error restoring project in activity history:', error)

    yield put({
      type: activityHistoryActions.setIsLoaded.type,
    })
  } finally {
    yield put({
      type: activityHistoryActions.setIsLoaded.type,
    })
  }
}
